import React from "react";
import Image from "src/bepaid/components/Image";
import { BrowserView, MobileView } from "react-device-detect";
import GuestLayout from "src/bepaid/layouts/GuestLayout";
import HeaderLogo from "src/bepaid/assets/images/desktop/header_ipaymy_logo.svg";
import * as queryString from "query-string";
import T from "src/ipm-shared/Utils/Intl";
import classNames from "classnames";
import FormStyles from "src/bepaid/components/Form/CommonForm.module.scss";
import IconPaymentSuccessful from "src/bepaid/assets/images/payments/payment_successful.svg";
import {
  extractDateFromQueryParam,
  formatDate
} from "src/bepaid/shared/modals/PaymentResultModal/components/utils";
import styles from "./PaymentApproval.module.scss";

const PaymentApproval: React.FC<any> = props => {
  const qs = queryString.parse(window.location.search);
  const { status } = qs;
  const chargeDate = extractDateFromQueryParam(qs, "charged_date");

  const getApprovalMessage = () => {
    switch (status) {
      case "pending":
        return "Thank you for approving the payment. We are pending 1 more approval before we can process the payment on";
      case "approved":
        return "Thank you for approving the payment. We will proceed to process the payment on";
      case "already_approved":
        return "These payments have already been approved by 2 other approvers and are scheduled to be charged on";
      default:
        return "These payments have already been approved by 2 other approvers and are scheduled to be charged on";
    }
  };

  function renderContent() {
    return (
      <div className={styles.wrapper}>
        <div className={classNames(FormStyles.content, styles.invoiceInfo)}>
          <div
            className={classNames(
              FormStyles.personalFormDetail,
              styles.formDetail
            )}
          >
            <div className={styles.formItem}>
              <div className={styles.wrapperIcon}>
                <Image src={IconPaymentSuccessful} className={styles.logo} />
              </div>
              <h2 className={styles.firstLetterCapitalize}>Payment approved</h2>
              <br />
              {getApprovalMessage()} <b>{formatDate(chargeDate)}</b>
              <br />
              <p className={styles.normalText}>
                {T.transl("PAYMENT_CONFIRMATION_CONTACT")}{" "}
                <a href="https://help.ipaymy.com/en/" target={"_blank"}>
                  support@ipaymy.com
                </a>
              </p>
            </div>
          </div>
        </div>
      </div>
    );
  }

  function renderDesktopView() {
    return <div className={styles.wrapperDesktop}>{renderContent()}</div>;
  }

  return (
    <GuestLayout header={<Image src={HeaderLogo} />}>
      <BrowserView>{renderDesktopView()}</BrowserView>
      <MobileView>
        <div className={styles.wrapperMobile}>{renderContent()}</div>
      </MobileView>
    </GuestLayout>
  );
};

export default PaymentApproval;
